import * as React from "react"
import styled from "styled-components"
import WarningIcon from "../atoms/icons/WarningIcon"
import { motion } from "framer-motion"
import { MediaQuery } from "../../utils/design-helpers"

interface ProgressBarProps {
  currentProgress: number //percentage
  warning?: boolean
  warningMax?: number
  warningMin?: number
  border?: boolean
  disabled?: boolean
}

const BarContainer = styled.div<{ border: boolean }>`
  height: 12px;
  width: 100%;
  background-color: ${(props) => props.theme.colors.white};
  border-radius: 20px;
  transform: scale(0.8);
  ${(props) => props.border && `outline: 0.5px solid ${props.theme.colors.greyDark}`};
  overflow: hidden;

  ${MediaQuery.XL} {
    transform: scale(1);
  }
  ${MediaQuery.XS} {
    transform: scale(1);
  }
`

const ProgressLine = styled.div<{ progress: number; warning?: boolean }>`
  height: 12px;
  width: ${(props) => `${props.progress}%`};
  background-color: ${(props) => (props.warning ? props.theme.colors.red : props.theme.colors.greenDark)};
  border-radius: 20px;
  z-index: 2;
`

const WarningIconContainer = styled.div`
  position: absolute;
  top: -12px;
  left: calc(50% - 12px);
`

const ProgressBar: React.FunctionComponent<ProgressBarProps> = ({
  currentProgress,
  warning,
  warningMax,
  warningMin,
  border = false,
  disabled = false,
}) => {
  if (!warning) {
    if (warningMax && currentProgress >= warningMax) {
      warning = true
    }
    if (warningMin && currentProgress <= warningMin) {
      warning = true
    }
  }

  return (
    <div style={{ position: "relative", opacity: disabled ? 0.3 : 1 }}>
      <BarContainer border={border}>
        <motion.div initial={{ width: 0 }} animate={{ width: "100%" }} transition={{ duration: 1, ease: "easeIn" }}>
          <ProgressLine progress={currentProgress} warning={warning} />
        </motion.div>
      </BarContainer>
      {warning && (
        <WarningIconContainer>
          <WarningIcon />
        </WarningIconContainer>
      )}
    </div>
  )
}

export default ProgressBar
